import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { FaUserCircle } from 'react-icons/fa';
import ProfileModal from '../Profile';
import adminBg from '../../Assets/bg/adminbg.jpg';

const NavbarNoso = ({ isSidebarExpanded, darkMode }) => {
  const [isProfileModalVisible, setProfileModalVisible] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 10);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleProfileClick = () => {
    setProfileModalVisible(true);
  };

  const handleCloseModal = () => {
    setProfileModalVisible(false);
  };

  useEffect(() => {
    if (darkMode) {
      document.body.classList.add('dark-mode');
    } else {
      document.body.classList.remove('dark-mode');
    }
  }, [darkMode]);

  return (
    <NavbarContainer darkMode={darkMode} isSidebarExpanded={isSidebarExpanded} scrolled={scrolled}>
      <CenteredMessage darkMode={darkMode}>Welcome to Noso Dashboard</CenteredMessage>

      <LeftSection>
        <ProfileWrapper onClick={handleProfileClick}>
          <ProfileIconContainer>
            <FaUserCircle style={styles.profileIcon} />
            <TooltipAccount className="tooltip">Account</TooltipAccount>
          </ProfileIconContainer>
        </ProfileWrapper>
      </LeftSection>
      {isProfileModalVisible && <ProfileModal onClose={handleCloseModal} />}
    </NavbarContainer>
  );
};

export default NavbarNoso;

const NavbarContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  position: fixed;
  top: 0;
  left: ${({ isSidebarExpanded }) => (isSidebarExpanded ? '180px' : '60px')};
  width: ${({ isSidebarExpanded }) => (isSidebarExpanded ? 'calc(100% - 180px)' : 'calc(100% - 60px)')};
  padding: 0 10px;
  transition: left 0.3s ease, width 0.3s ease;
  z-index: 1000;

  background-color: ${({ darkMode }) => (darkMode ? 'transparent' : 'white')};
  background-image: ${({ darkMode }) => (darkMode ? `url(${adminBg})` : 'none')};
  background-size: cover;

  box-shadow: ${({ scrolled }) =>
    scrolled ? '0 4px 12px rgba(0, 0, 0, 0.2)' : 'none'};

  @media (max-width: 768px) {
    left: 0;
    width: 100%;
  }
`;

const CenteredMessage = styled.p`
  flex: 1;
  margin: 0;
  text-align: center;
  font-size: clamp(14px, 4vw, 16px);
  font-weight: 600;
  color: ${({ darkMode }) => (darkMode ? '#ffffff' : '#333333')};
`;

const LeftSection = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;

const ProfileWrapper = styled.div`
  position: relative;

  &:hover .tooltip {
    opacity: 1;
    visibility: visible;
  }
`;

const ProfileIconContainer = styled.div`
  cursor: pointer;
  color: #4d4d4d;
  font-size: 24px;
  margin-right: 15px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #ffffff;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  border: 2px solid #4d4d4d;
  position: relative;
`;


const TooltipAccount = styled.div`
  visibility: hidden;
  opacity: 0;
  position: absolute;
  bottom: -30px;
  left: 50%;
  transform: translateX(-50%);
  background-color: #333;
  color: #fff;
  padding: 5px 10px;
  font-size: 12px;
  border-radius: 5px;
  transition: opacity 0.3s ease, visibility 0.3s ease;

  ${ProfileWrapper}:hover & {
    visibility: visible;
    opacity: 1;
  }
`;

const styles = {
  icon: (isActive) => ({
    fontSize: '24px',
    color: isActive ? '#28a745' : '#4d4d4d',
    marginRight: '20px',
  }),
  searchIcon: {
    fontSize: '15px',
    color: '#4d4d4d',
  },
  profileIcon: {
    fontSize: '25px',
    color: '#4d4d4d',
  },
};

